export default __webpack_public_path__ + "static/media/image.imara-software-solutions-pvt-ltd-.7b257ad9.png";